import{OverflowList}from '@theme/overflow-list';import VariantPicker from '@theme/variant-picker';import{Component}from '@theme/component';import{debounce,isDesktopBreakpoint,mediaQueryLarge,yieldToMainThread}from '@theme/utilities';import{ThemeEvents,VariantSelectedEvent,VariantUpdateEvent,SlideshowSelectEvent}from '@theme/events';import{morph}from '@theme/morph';export class ProductCardLink extends Component{get productTransitionEnabled(){return this.getAttribute('data-product-transition')==='true'}
get featuredMediaUrl(){return this.getAttribute('data-featured-media-url')}
handleViewTransition(event){if(event.defaultPrevented)return;if(event.target instanceof Element){const interactiveElement=event.target.closest('button, input, label, select, [tabindex="1"]');if(interactiveElement)return}
if(!this.productTransitionEnabled)return;const{cardGallery}=this.refs;if(!cardGallery||!cardGallery.hasAttribute('data-view-transition-to-main-product'))return;const{imagesToTransition}=this.refs;const activeImage=imagesToTransition?.find((image)=>image.closest('slideshow-slide')?.getAttribute('aria-hidden')==='false')||imagesToTransition?.[imagesToTransition.length-1];if(activeImage instanceof HTMLImageElement)this.#setImageSrcset(activeImage);cardGallery.setAttribute('data-view-transition-type','product-image-transition');cardGallery.setAttribute('data-view-transition-triggered','true')}
#setImageSrcset(image){if(!this.featuredMediaUrl)return;const currentImageUrl=new URL(image.currentSrc);const currentImageRawUrl=currentImageUrl.host+currentImageUrl.pathname;if(!this.featuredMediaUrl.includes(currentImageRawUrl)){const imageFade=image.animate([{opacity:0.8},{opacity:1}],{duration:125,easing:'ease-in-out',});imageFade.onfinish=()=>{image.srcset=this.featuredMediaUrl??''}}}}
if(!customElements.get('product-card-link')){customElements.define('product-card-link',ProductCardLink)}
export class ProductCard extends ProductCardLink{requiredRefs=['productCardLink'];get productPageUrl(){return this.refs.productCardLink.href}
getSelectedVariantId(){const checkedInput=(this.querySelector('input[type="radio"]:checked[data-variant-id]'));return checkedInput?.dataset.variantId||null}
getProductCardLink(){return this.refs.productCardLink||null}
#fetchProductPageHandler=()=>{this.refs.quickAdd?.fetchProductPage(this.productPageUrl)};#navigateToURL=(event,url)=>{const shouldOpenInNewTab=event instanceof MouseEvent&&(event.metaKey||event.ctrlKey||event.shiftKey||event.button===1);if(shouldOpenInNewTab){event.preventDefault();window.open(url.href,'_blank');return}else{window.location.href=url.href}};connectedCallback(){super.connectedCallback();const link=this.refs.productCardLink;if(!(link instanceof HTMLAnchorElement))throw new Error('Product card link not found');this.#handleQuickAdd();this.addEventListener(ThemeEvents.variantUpdate,this.#handleVariantUpdate);this.addEventListener(ThemeEvents.variantSelected,this.#handleVariantSelected);this.addEventListener(SlideshowSelectEvent.eventName,this.#handleSlideshowSelect);mediaQueryLarge.addEventListener('change',this.#handleQuickAdd);this.addEventListener('click',this.navigateToProduct);setTimeout(()=>{if(this.refs.slideshow?.isNested){this.#preloadNextPreviewImage()}})}
disconnectedCallback(){super.disconnectedCallback();this.removeEventListener('click',this.navigateToProduct)}
#preloadNextPreviewImage(){const currentSlide=this.refs.slideshow?.slides?.[this.refs.slideshow?.current];currentSlide?.nextElementSibling?.querySelector('img[loading="lazy"]')?.removeAttribute('loading')}
#handleQuickAdd=()=>{this.removeEventListener('pointerenter',this.#fetchProductPageHandler);this.removeEventListener('focusin',this.#fetchProductPageHandler);if(isDesktopBreakpoint()){this.addEventListener('pointerenter',this.#fetchProductPageHandler);this.addEventListener('focusin',this.#fetchProductPageHandler)}};#handleVariantSelected=(event)=>{if(event.target!==this.variantPicker){this.variantPicker?.updateSelectedOption(event.detail.resource.id)}};#handleVariantUpdate=(event)=>{event.stopPropagation();this.updatePrice(event);this.#isUnavailableVariantSelected(event);this.#updateProductUrl(event);this.refs.quickAdd?.fetchProductPage(this.productPageUrl);if(event.target!==this.variantPicker){this.variantPicker?.updateVariantPicker(event.detail.data.html)}
this.#updateVariantImages();this.#previousSlideIndex=null;this.removeAttribute('data-no-swatch-selected');this.#updateOverflowList()};#updateOverflowList(){const overflowList=this.querySelector('swatches-variant-picker-component overflow-list');const isActiveOverflowList=overflowList?.querySelector('[slot="overflow"]')?!0:!1;if(!overflowList||!isActiveOverflowList)return;requestAnimationFrame(()=>{overflowList.dispatchEvent(new CustomEvent('reflow',{bubbles:!0,detail:{},}))})}
updatePrice(event){const priceContainer=this.querySelectorAll(`product-price [ref='priceContainer']`)[1];const newPriceElement=event.detail.data.html.querySelector(`product-price [ref='priceContainer']`);if(newPriceElement&&priceContainer){morph(priceContainer,newPriceElement)}}
#updateProductUrl(event){const responseProductCard=event.detail.data.html?.querySelector('product-card');const anchorElement=responseProductCard?.querySelector('a');const featuredMediaUrl=responseProductCard?.getAttribute('data-featured-media-url');if(featuredMediaUrl){this.setAttribute('data-featured-media-url',featuredMediaUrl)}
if(anchorElement instanceof HTMLAnchorElement){if(anchorElement.getAttribute('href')?.trim()==='')return;const productUrl=anchorElement.href;const{productCardLink,productTitleLink,cardGalleryLink}=this.refs;productCardLink.href=productUrl;if(cardGalleryLink instanceof HTMLAnchorElement){cardGalleryLink.href=productUrl}
if(productTitleLink instanceof HTMLAnchorElement){productTitleLink.href=productUrl}}}
#isUnavailableVariantSelected(event){const allVariants=(event.detail.data.html.querySelectorAll('input:checked'));for(const variant of allVariants){this.#toggleAddToCartButton(variant.dataset.optionAvailable==='true')}}
#toggleAddToCartButton(enable){const addToCartButton=this.querySelector('.add-to-cart__button button');if(addToCartButton instanceof HTMLButtonElement){addToCartButton.disabled=!enable}}
#updateVariantImages(){const{slideshow}=this.refs;if(!this.variantPicker?.selectedOption){return}
const selectedImageId=this.variantPicker?.selectedOption.dataset.optionMediaId;if(slideshow&&selectedImageId){const{slides=[]}=slideshow.refs;for(const slide of slides){if(slide.getAttribute('variant-image')==null)continue;slide.hidden=slide.getAttribute('slide-id')!==selectedImageId}
slideshow.select({id:selectedImageId},undefined,{animate:!1})}}
get allVariants(){return this.querySelectorAll('input[data-variant-id]')}
get variantPicker(){return this.querySelector('swatches-variant-picker-component')}
#previousSlideIndex=null;#handleSlideshowSelect=(event)=>{if(event.detail.userInitiated){this.#previousSlideIndex=event.detail.index}};previewVariant(id){const{slideshow}=this.refs;if(!slideshow)return;this.resetVariant.cancel();slideshow.select({id},undefined,{animate:!1})}
previewImage(event){if(event.pointerType!=='mouse')return;const{slideshow}=this.refs;if(!slideshow)return;this.resetVariant.cancel();if(this.#previousSlideIndex!=null&&this.#previousSlideIndex>0){slideshow.select(this.#previousSlideIndex,undefined,{animate:!1})}else{slideshow.next(undefined,{animate:!1});setTimeout(()=>this.#preloadNextPreviewImage())}}
resetImage(event){if(event.pointerType!=='mouse')return;const{slideshow}=this.refs;if(!this.variantPicker){if(!slideshow)return;slideshow.previous(undefined,{animate:!1})}else{this.#resetVariant()}}
#resetVariant=()=>{const{slideshow}=this.refs;if(!slideshow)return;if(this.variantPicker?.selectedOption){const id=this.variantPicker.selectedOption.dataset.optionMediaId;if(id){slideshow.select({id},undefined,{animate:!1});return}}
const initialSlide=slideshow.initialSlide;const slideId=initialSlide?.getAttribute('slide-id');if(initialSlide&&slideshow.slides?.includes(initialSlide)&&slideId){slideshow.select({id:slideId},undefined,{animate:!1});return}
slideshow.previous(undefined,{animate:!1})};navigateToProduct=(event)=>{if(!(event.target instanceof Element))return;if(this.hasAttribute('data-no-navigation'))return;const interactiveElement=event.target.closest('button, input, label, select, [tabindex="1"]');if(interactiveElement){return}
const link=this.refs.productCardLink;if(!link.href)return;const linkURL=new URL(link.href);const productCardAnchor=link.getAttribute('id');if(!productCardAnchor)return;const infiniteResultsList=this.closest('results-list[infinite-scroll="true"]');if(!window.Shopify.designMode&&infiniteResultsList){const url=new URL(window.location.href);const parent=this.closest('li');url.hash=productCardAnchor;if(parent&&parent.dataset.page){url.searchParams.set('page',parent.dataset.page)}
yieldToMainThread().then(()=>{history.replaceState({},'',url.toString())})}
const targetLink=event.target.closest('a');if(!targetLink){this.#navigateToURL(event,linkURL)}};resetVariant=debounce(this.#resetVariant,100)}
if(!customElements.get('product-card')){customElements.define('product-card',ProductCard)}
class SwatchesVariantPickerComponent extends VariantPicker{connectedCallback(){super.connectedCallback();this.parentProductCard=this.closest('product-card');this.addEventListener(ThemeEvents.variantUpdate,this.#handleCardVariantUrlUpdate.bind(this))}
#handleCardVariantUrlUpdate(){if(this.pendingVariantId&&this.parentProductCard instanceof ProductCard){const currentUrl=new URL(this.parentProductCard.refs.productCardLink.href);currentUrl.searchParams.set('variant',this.pendingVariantId);this.parentProductCard.refs.productCardLink.href=currentUrl.toString();this.pendingVariantId=null}}
variantChanged(event){if(!(event.target instanceof HTMLElement))return;const isSwatchInput=event.target instanceof HTMLInputElement&&event.target.name?.includes('-swatch');const clickedSwatch=event.target;const availableCount=parseInt(clickedSwatch.dataset.availableCount||'0');const firstAvailableVariantId=clickedSwatch.dataset.firstAvailableOrFirstVariantId;if(isSwatchInput&&availableCount>0&&firstAvailableVariantId){event.stopPropagation();this.updateSelectedOption(clickedSwatch);const productUrl=this.dataset.productUrl?.split('?')[0];if(!productUrl)return;const url=new URL(productUrl,window.location.origin);url.searchParams.set('variant',firstAvailableVariantId);url.searchParams.set('section_id','section-rendering-product-card');const requestUrl=url.href;this.pendingVariantId=firstAvailableVariantId;this.fetchUpdatedSection(requestUrl);return}
super.variantChanged(event)}
showAllSwatches(event){event?.preventDefault();const{overflowList}=this.refs;if(overflowList instanceof OverflowList){overflowList.showAll()}}}
if(!customElements.get('swatches-variant-picker-component')){customElements.define('swatches-variant-picker-component',SwatchesVariantPickerComponent)}
(function () {
  if (window.__wbgProductCardColorVariantsLoaded) return;
  window.__wbgProductCardColorVariantsLoaded = true;

  function getProductCardImage(card) {
    return (
      card.querySelector('slideshow-slide[aria-hidden="false"] img') ||
      card.querySelector('.product-card__content img') ||
      card.querySelector('img')
    );
  }

  function getProductCardVariants(card) {
    return Array.from(card.querySelectorAll('.product-card__color-variant'));
  }

  function getCurrentColorIndex(card) {
    return Number(card.dataset.currentColorIndex || 0);
  }

  function setCurrentColorIndex(card, index) {
    card.dataset.currentColorIndex = String(index);
  }

  function rememberOriginalProductCardState(card) {
    const mainImage = getProductCardImage(card);
    const productLink = card.querySelector('.product-card__link');

    if (!mainImage) return;

    if (!card.dataset.originalImageSrc) {
      card.dataset.originalImageSrc = mainImage.currentSrc || mainImage.src || '';
      card.dataset.originalImageSrcset = mainImage.srcset || '';
    }

    if (productLink && !card.dataset.originalProductHref) {
      card.dataset.originalProductHref = productLink.href || '';
    }
  }

  function showProductCardColor(card, index) {
    const variants = getProductCardVariants(card);
    const variant = variants[index];
    const mainImage = getProductCardImage(card);
    const productLink = card.querySelector('.product-card__link');

    if (!variant || !mainImage) return;

    rememberOriginalProductCardState(card);

    const newImage = variant.dataset.variantImage;
    const newUrl = variant.dataset.variantUrl;

    if (newImage) {
      mainImage.src = newImage;
      mainImage.srcset = '';
    }

    if (productLink && newUrl) {
      productLink.href = newUrl;
    }

    setCurrentColorIndex(card, index);
  }

  function resetProductCardColor(card) {
    const mainImage = getProductCardImage(card);
    const productLink = card.querySelector('.product-card__link');

    if (!mainImage) return;

    if (card.dataset.originalImageSrc) {
      mainImage.src = card.dataset.originalImageSrc;
      mainImage.srcset = card.dataset.originalImageSrcset || '';
    }

    if (productLink && card.dataset.originalProductHref) {
      productLink.href = card.dataset.originalProductHref;
    }

    setCurrentColorIndex(card, 0);
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      const card = event.target.closest('product-card');
      if (!card) return;

      const variants = getProductCardVariants(card);
      if (variants.length < 2) return;

      if (!card.contains(event.relatedTarget)) {
        showProductCardColor(card, 1);
      }
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      const card = event.target.closest('product-card');
      if (!card) return;

      const variants = getProductCardVariants(card);
      if (variants.length < 2) return;

      if (!card.contains(event.relatedTarget)) {
        resetProductCardColor(card);
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      const arrow = event.target.closest('.product-card__color-arrow');
      if (!arrow) return;

      const card = arrow.closest('product-card');
      if (!card) return;

      const variants = getProductCardVariants(card);
      if (variants.length < 2) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const currentIndex = getCurrentColorIndex(card);

      let nextIndex;

      if (arrow.classList.contains('product-card__color-arrow--prev')) {
        nextIndex = currentIndex === 0 ? variants.length - 1 : currentIndex - 1;
      } else {
        nextIndex = currentIndex >= variants.length - 1 ? 0 : currentIndex + 1;
      }

      showProductCardColor(card, nextIndex);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const arrow = event.target.closest('.product-card__color-arrow');
      if (!arrow) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );
})();